import ENTITIES_TYPES from '../../containers/Music/EntityType';
import logger from 'src/utils/logger/logger';

const MusicDetailAdapter = resp => {
    let result = [];
    if (!(resp && resp.response && Array.isArray(resp.response.components))) {
        logger.debug('La api no contiene componentes');
        return result;
    }

    resp.response.components.forEach(section => {
        if (section.type === 'GRID') {
            result = section.items.map(el => {
                let obj = {};
                switch (el.entity) {
                    case ENTITIES_TYPES.PLAYLIST:
                        obj = {
                            author: el.author || '',
                            href: `/playlist/${el.entity_id}` || '',
                            id: el.entity_id || null,
                            image: el.img || null,
                            isFollowing: el.isFollowing || false,
                            numFollowers: el.followers || '',
                            title: el.title || '',
                            totalTime: el.duration || '',
                            type: el.entity || ''
                        };
                        break;
                    case ENTITIES_TYPES.ALBUM:
                        obj = {
                            artist: el.artistName || [],
                            artistId: el.artistId || null,
                            author: el.author || '',
                            href: `/album/${el.entity_id}` || '',
                            id: el.entity_id || null,
                            image: el.img || null,
                            title: el.title || '',
                            numTracks: el.num_tracks || 0,
                            type: el.entity || '',
                            isFavorite: el.isFavorite || false,
                            isFollowing: el.isFollowing || false
                        };
                        break;
                    case ENTITIES_TYPES.ARTIST:
                        obj = {
                            artist: el.title || '',
                            href: `/artist/${el.entity_id}` || '',
                            id: el.entity_id || null,
                            image: el.img || null,
                            isFavorite: el.isFavorite || false,
                            type: el.entity || ''
                        };
                        break;
                    case ENTITIES_TYPES.RADIO:
                        obj = {
                            band: el.band || '',
                            dial: el.dial || '',
                            encoding: el.encoding || '',
                            id: el.entity_id || null,
                            image: el.img || null,
                            title: el.title || '',
                            type: el.entity || '',
                            url: el.service_url || ''
                        };
                        break;
                    default:
                        break;
                }
                return obj;
            });
            logger.debug('transformApiResponse');
        }
    });
    return result;
};

export default MusicDetailAdapter;



// WEBPACK FOOTER //
// ./src/components/MyMusicContent/MusicDetailAdapter.js